import { SignatureFormat } from '../signature-types';
import { decodeDataUrl } from './data-url';
export const isExternalImage = value => {
  const valueUrl = value.url;
  const {
    type
  } = decodeDataUrl(valueUrl) ?? {};
  const drawable = !valueUrl || type === SignatureFormat.POINTS;
  const writable = drawable || type === SignatureFormat.TEXT;
  return !drawable && !writable;
};
export const getSignaturePenColorWUT = compId => {
  if (typeof window === 'undefined') {
    return;
  }
  const dataHook = `[id=${compId}] [data-hook="form-root"]`;
  const element = document.querySelector(dataHook);
  const formInputValueColor = element ? getComputedStyle(element).getPropertyValue('--wix-forms-formInputValueColor') : undefined;
  return formInputValueColor ? `rgb(${formInputValueColor})` : undefined;
};
export const getSignaturePenColorWDS = compId => {
  if (typeof window === 'undefined') {
    return;
  }
  const dataHook = `[id=${compId}] [data-hook="form-root"]`;
  const element = document.querySelector(dataHook);
  const formInputValueColor = element ? getComputedStyle(element).getPropertyValue('--wds-color-text-standard-primary') : undefined;
  return formInputValueColor;
};
//# sourceMappingURL=drawer.js.map